import { Suspense } from "react";
import AppRouter from "./Routers/AppRouter";

function MainRouter() {
  return (
    <Suspense>
      <AppRouter />
    </Suspense>
  );
}

export default MainRouter;
